import { Difference, Expand } from '@mui/icons-material';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { Dispatch, ReactNode, SetStateAction } from 'react';

import styles from './DiffContainer.module.scss';


export interface DiffContainerProps {
    children: ReactNode;
    hideUnchanged: boolean;
    setHideUnchanged?: Dispatch<SetStateAction<boolean>>;
    allowHideUnchanged?: boolean;
}

export function DiffContainer({
    children, hideUnchanged, setHideUnchanged, allowHideUnchanged
}: DiffContainerProps) {
    return (
        <div className={styles.root}>
            {allowHideUnchanged && (
                <>
                    <Typography
                        color="textSecondary"
                        variant="body2"
                        fontWeight={500}
                        className={styles.statusText}
                    >
                        {hideUnchanged ? 'Showing differences' : 'Showing all values'}
                    </Typography>

                    <Tooltip title={hideUnchanged ? 'Show all values' : 'Show differences'}>
                        <IconButton
                            className={styles.button}
                            onClick={() => setHideUnchanged?.(!hideUnchanged)}
                        >
                            {hideUnchanged ? (
                                <Expand color="secondary" />
                            ) : (
                                <Difference color="secondary" />
                            )}
                        </IconButton>
                    </Tooltip>
                </>
            )}

            {children}

            {allowHideUnchanged && ( // This div is hidden with CSS if there are no additional children
                <div className={styles.noChange}>
                    There are no differences to display for this update
                </div>
            )}
        </div>
    );
}
